import { blocklyStore } from '../blocklyStore';
import { AssembleCodeEnum } from '../BlocklyAframeBuilder';
import '../../helper/animationLoops';
import { LibAtt } from '../AbstractBlock';
import { CodeSetting } from './CodeSetting';
import { block_translation } from '../../lang/BlockTranslation';
const t = block_translation;
export class ModelViewSetting {
  /**
   * JSでシーンを生成するコードを返す
   */
  static getModelViewJSCode(
    tagname: string,
    attribute: string,
    fragmentName: string,
    subBlock: string
  ): string {
    console.log('sub', subBlock);
    const jsCode = `
			parent = ${fragmentName}
      ${CodeSetting.getElementCode(tagname, attribute, '', subBlock)}
		`;
    console.log('jscode', jsCode);
    return jsCode;
  }

  /**
   * シーンのコードを作成
   * @param {*} attribute
   * @param {*} subBlock
   */
  static getModelViewCode(
    tagname: string,
    libs: LibAtt[],
    attribute: string,
    subBlock: string,
    placeType: string
  ): string {
    console.log('getModelViewCode', tagname);
    const helpText = t.to(
      `「ARを体験！」でカメラ画面が開きます<br>
      カメラ画面で<b>__PLACE__</b>をなぞって、ARを配置しましょう<br>
      ピンチ操作で拡大縮小ができます。`,
      'ar_help_text'
    );
    console.log('helpText', helpText);
    const place = placeType === 'floor' ? t.to('床', 'floor_place') : t.to('壁', 'wall_place');
    const helpString = helpText.replace('__PLACE__', place);

    // JSでのDOM生成コードを評価して、blockvrockVirtualDOM変数に貯める
    const blockvrockVirtualDOM = document.createDocumentFragment();

    const modelViewCode = this.getModelViewJSCode(
      tagname,
      attribute,
      'blockvrockVirtualDOM',
      subBlock
    );

    // バックグラウンド含めたコード
    const jsSceneCreateCode = modelViewCode;
    console.log('jsSceneCreateCode', jsSceneCreateCode);
    // vdom を作るコードをおいとく
    blocklyStore.virtual_dom_js = `let blockvrockVirtualDOM = document.createDocumentFragment();
      ${jsSceneCreateCode}`;

    // JS評価実施！
    eval(jsSceneCreateCode);

    // フラグメントからHTMLを取り出す
    const htmlSceneCode = CodeSetting.convertFragmentToHTMLString(blockvrockVirtualDOM);
    // Bodyに登録する文字列に追加
    const str = `
      <html>
      <head>
      <meta charset="UTF-8" />
      <meta http-equiv="X-UA-Compatible" content="IE=edge" />
      <meta name="viewport" content="width=device-width, initial-scale=1.0" />
      <link href="../public/lib/bootstrap@5.0.2.min.css" rel="stylesheet"  crossorigin="anonymous">
      <script src="../public/bootstrap@5.0.2.min.js"  crossorigin="anonymous"></script>

      ${libs.map((i) => `<script ${i.attr} src="${i.libs}" ></script>`).join('')}
      <style>
      html, body {
        width: 100%;
        height: 100%;
      }

      model-viewer {
        width: 100%;
        height: 100%;
      --poster-color: transparent;
      }


      .dialog-place {
        width: 80%;
        top:10rem;
        z-index:2000;
      }
      </style>
      <script>
        const openD = () =>{
          const help = document.getElementById('help')
          help.classList.toggle("d-none");
          help.show();
        } 
        const closeD = () =>{
          const help = document.getElementById('help')
          help.classList.toggle("d-none");
          help.close();
        }
      </script>
      </head>
      <body>

        <dialog id="help" class="card dialog-place d-none position-absolute" >
            <button
              class="btn rounded-circle btn-outline-dark"
              style="position: absolute; top: -0.5rem; right: -0.5rem;z-index:1000"
              onclick="closeD()"
            >
              x
            </button>
          <div class="card-body">
            <p>${helpString}</p>
          </div>
        </dialog>
    
        <button 
          class="btn rounded-circle btn-outline-dark fixed-bottom p-1 m-4" 
          style="width:3rem; height :3rem; z-index:1000" 
          onclick="openD()">?</button>
        ${htmlSceneCode}
        <script type="text/javascript">
          ${AssembleCodeEnum.FUNC_PLACE_HOLER}
        </script>
      </body>
      </html>`;
    return str;
  }
}
